// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".heatmap-bar{padding:10px 10px 0px 10px}\n", "",{"version":3,"sources":["webpack://./src/styles/heatmap-bar.scss"],"names":[],"mappings":"AAAA,aACE,0BAA2B","sourcesContent":[".heatmap-bar {\n  padding: 10px 10px 0px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
